import { APIManager, axios } from 'shared/manager';
import { RestEnds } from 'shared/Constants';

const login = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.LOGIN, data, false, {}, {}, axios);

const register = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.LOGIN, data, false, {}, {}, axios);

const getOrgList = async (): Promise<any> =>
  APIManager.sendGet(RestEnds.ORG_LIST, true, {}, {}, axios);

const getOrgAccessToken = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.OGR_ACCESS_TOKEN, data, true, {}, {}, axios);

const validateInvite = async (id: string): Promise<any> =>
  APIManager.sendGet(RestEnds.INVITE_DETAIL(id), false, {}, {}, axios);

const acceptInvite = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RestEnds.ACCEPT_INVITE_DETAIL,
    data,
    false,
    {},
    {},
    axios
  );

const forgetPassword = async (email: string): Promise<any> =>
  APIManager.sendPost(
    RestEnds.FORGET_PASSWORD(email),
    false,
    false,
    {},
    {},
    axios
  );

const resetPassword = async (token: string, password: string): Promise<any> =>
  APIManager.sendPost(
    RestEnds.RESET_PASSWORD(token, password),
    false,
    false,
    {},
    {},
    axios
  );

const validateToken = async (token: string): Promise<any> =>
  APIManager.sendGet(RestEnds.VALID_TOKEN(token), false, {}, {}, axios);

const sendOTP = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.SEND_OTP, data, true, {}, {}, axios);

const twoFALogin = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.TWO_FA_LOGIN, data, true, {}, {}, axios);

const ssoLogin = async (data: any): Promise<any> =>
  APIManager.sendPost(RestEnds.SSO_LOGIN, data, false, {}, {}, axios);

export const AuthenticationService = {
  login,
  getOrgList,
  getOrgAccessToken,
  register,
  registerTenant: register,
  validateInvite,
  acceptInvite,
  forgetPassword,
  resetPassword,
  validateToken,
  sendOTP,
  twoFALogin,
  ssoLogin,
};
